import { popinApi } from './api';

export const userDelegateApi = {

  /**
   * Gets a list of your delegates, regardless of delegate session or not
   * @return {Promise<object>}
   */
  getMyDelegates: () => {
    return popinApi.get(`/userdelegate/delegatefor`);
  },

  become: (userId) => {
    return Promise.resolve().then(() => {
      if (!userId) {
        throw Error('Must provide a userId to become()');
      } else {
        return popinApi.post(`/userdelegate/become`, {
          user_id: userId
        });
      }
    });
  }
};
